import { useState } from "react";
import { useEffect } from "react";
import { convertToGregorian, convertToJalaliWithoutTime, currentYear, isEmpty } from "../../tools/tools";
import { Select } from "antd";
const DatePicker = ({ values, onChange, lang = true, className }) => {
  const [sltDate, setSltDate] = useState(values || { day: "", month: "", year: "" });
  useEffect(() => {
    if (!isEmpty(values)) {
      values = lang ? convertToJalaliWithoutTime(values, "/") : values;
      let year = parseInt(values.split("/")[0]);
      let month = parseInt(values.split("/")[1]);
      let day = parseInt(values.split("/")[2]);
      setSltDate({ day: day, month: month, year: year });
    } else {
      setSltDate({ day: "", month: "", year: "" });
    }
  }, [values, lang]);
  const setStartYear = lang
    ? currentYear(new Date().getFullYear() - 18 + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate())
    : new Date().getFullYear() - 18;
  const years = Array.from({ length: 100 }, (_, index) => setStartYear - index);
  const months = lang
    ? ["فروردین", "اردیبهشت", "خرداد", "تیر", "مرداد", "شهریور", "مهر", "آبان", "آذر", "دی", "بهمن", "اسفند"]
    : ["ژانویه", "فوریه", "مارس", "آوریل", "مه", "ژوئن", "ژوئیه", "اوت", "سپتامبر", "اکتبر", "نوامبر", "دسامبر"];
  const day = Array.from({ length: 31 }, (_, index) => index + 1);
  const handleDateChange = (changedDate) => {
    setSltDate(changedDate);
    if (changedDate?.year && changedDate?.month && changedDate?.day) {
      // onChange(changedDate);
      try {
        if (lang) {
          onChange(convertToGregorian(changedDate.year + "/" + ("0" + changedDate.month).slice(-2) + "/" + ("0" + changedDate.day).slice(-2)));
        } else {
          onChange(changedDate.year + "/" + ("0" + changedDate.month).slice(-2) + "/" + ("0" + changedDate.day).slice(-2));
        }
      } catch (error) {
        onChange("00/00/00");
      }
    }
  };
  return (
    <>
      <style>
        {`
  .component-datepicker {
    display: flex;
    gap: .5rem;
    .ant-select {
      flex: 1;
    }
`}
      </style>
      <div className={`${className} component-datepicker`}>
        <Select
          style={{ minWidth: "80px" }}
          placeholder="روز"
          className="datepicker-day"
          value={sltDate.day}
          onChange={(value) => handleDateChange({ ...sltDate, day: value })}
        >
          {/* <Select.Option value="">روز</Select.Option> */}
          {day.map((day) => (
            <Select.Option key={day} value={day}>
              {day}
            </Select.Option>
          ))}
        </Select>
        <Select
          style={{ minWidth: "120px" }}
          className="datepicker-month"
          value={sltDate.month}
          placeholder="ماه"
          onChange={(value) => handleDateChange({ ...sltDate, month: value })}
        >
          {/* <Select.Option value="">ماه</Select.Option> */}
          {months.map((month, index) => (
            <Select.Option key={month} value={index + 1}>
              {month}
            </Select.Option>
          ))}
        </Select>
        <Select
          className="datepicker-year"
          value={sltDate.year}
          placeholder="سال"
          onChange={(value) => handleDateChange({ ...sltDate, year: value })}
        >
          {/* <Select.Option value="">سال</Select.Option> */}
          {years.map((year) => (
            <Select.Option key={year} value={year}></Select.Option>
          ))}
        </Select>
      </div>
    </>
  );
};

export default DatePicker;
